import actions from "@/store/modules/employee/actions";
import mutations from "@/store/modules/employee/mutations";
import state from "@/store/modules/employee/state";

export default {
    actions,
    mutations,
    state
}